
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { GeoDatumDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-geo-datum',
  templateUrl: './geo-datum.component.html',
  styleUrls: ['./geo-datum.component.scss']
})
export class GeoDatumComponent implements OnChanges {


  geodatumForm: FormGroup;
  geodatumFormArray: FormGroup;
  control = new FormControl();
  @Input() geodatums: GeoDatumDto[];
  @Input() routeAnimationsElements: any;
  @Output() geodatum = new EventEmitter<GeoDatumDto[]>()
  @Output() deleteGeoDatumEvent = new EventEmitter<any>()

    selectedGeoDatum: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createGeoDatumForm();
    }

    createGeoDatumForm() {
      this.geodatumForm = this.fb.group({
        DatumName: ['', Validators.required],
     
        id: null
        });
        this.geodatumFormArray = this.fb.group({ GeoDatums: this.fb.array([])
          });
        this.setGeoDatum();
    }

  // method to display geodatums
  setGeoDatum() {
    const control  = this.geodatumFormArray.controls.GeoDatums as FormArray;
    this.geodatums.forEach( e => {
      control.push(
        this.fb.group({
          DatumName: e.DatumName,
        
          id: e.id
        })
      );
    });
  }


  // method to add GeoDatum
  addGeoDatum(value: GeoDatumDto) {
    const control  = this.geodatumFormArray.controls.GeoDatums as FormArray;
    control.insert(0,
          this.fb.group({
            DatumName: value.DatumName,
          
            id: null
          })
       );
  }

  selectGeoDatum(value) {}

  // method to delete geodatum from arrary list
  deleteGeoDatum(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.geodatumFormArray.controls.GeoDatums as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.geodatums.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.geodatums[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: GeoDatumDto) {
    if(this.geodatumForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.geodatumFormArray.get('GeoDatums')['controls'][this.selectedIndex].patchValue({DatumName: formValue.DatumName});
    } else {
      this.addGeoDatum(formValue);
    }
    this.selectedIndex = null;
    this.geodatumForm.reset()
  }

  onEdit(index, value: GeoDatumDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.geodatumForm.patchValue({DatumName: value.DatumName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.geodatumForm.reset();
  }

  onSubmit(formValue: GeoDatumDto[]) {
  this.geodatum.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteGeoDatumEvent.emit(this.filteredDelete);
  }
  }

}
